import { render } from "./ListSettings.vue?vue&type=template&id=90f31f18&scoped=true"
import script from "./ListSettings.vue?vue&type=script&lang=js"
export * from "./ListSettings.vue?vue&type=script&lang=js"

import "./ListSettings.vue?vue&type=style&index=0&id=90f31f18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f31f18"]])

export default __exports__